export default "__VITE_ASSET__CfQVR0Sa__"